export function base64ToBlob(base64, mimeType) {
    const byteString = atob(base64.split(',')[1]);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeType });
}

export function blobToFile(blob, fileName) {
    return new File([blob], fileName, { type: blob.type });
}

export function generateRandomId() {
    return Math.random()
        .toString(36)
        .substring(2, 15);
}
